module.exports = __webpack_public_path__ + "static/media/close.be929ad8.svg";